import { createContext } from "react";

interface ApplyWithSeekContextValue {
  applyWithSeekEnabled: boolean;
  seekId: string | null | undefined;
  jobPostUrl: string | null | undefined;
  jobPostId: string | null | undefined;
  isConfigured: boolean;
}

export const ApplyWithSeekContext = createContext<ApplyWithSeekContextValue>({
  applyWithSeekEnabled: false,
  seekId: null,
  jobPostUrl: null,
  jobPostId: null,
  isConfigured: false,
});
